<div class="next-step-button-wrapper">
  <div class="flex-row gap-10 next-step-button">
    <span>Next step</span>
    <span class="material-symbols-outlined blink"> stat_minus_2 </span>
  </div>
</div>
